import { createSlice } from "@reduxjs/toolkit";

const actionBtnSelectionTableRowsSlice = createSlice({
  name: "actionBtnSelectionTableRows",
  initialState: {
    getAllFn: () => {},
    menuItemActionBtnType: ['']
  },
  reducers: {
    addActionsSelectionTableRows(state, action) {
      const {getAllFn, menuItemActionBtnType} = action.payload
      state.getAllFn = getAllFn
      state.menuItemActionBtnType = menuItemActionBtnType
    },

  },
});
export const { addActionsSelectionTableRows } = actionBtnSelectionTableRowsSlice.actions;

export default actionBtnSelectionTableRowsSlice.reducer;
